import { Helmet } from "react-helmet";

import ApproachImage from "../assets/images/AboutApproach.svg";
import MissionImage from "../assets/images/AboutMission.svg";

const About = () => {
  return (
    <main>
      <Helmet>
        <title>About Us | Provido</title>
        <meta property="og:title" content="About Us | Provido" />
        <meta
          name="description"
          content="Learn about Provido and our approach to working with our clients."
        ></meta>
        <meta property="og:url" content="https://provido.com.au/about" />
        <meta name="twitter:title" content="About Us | Provido" />
      </Helmet>

      {/* Page Header */}
      <div className="grid w-dvw grid-cols-1 gap-12 bg-lightblue bg-[url(./assets/images/bubblebg.webp)] px-12 py-12 md:grid-cols-6 md:px-24 lg:gap-24 xl:px-48">
        <div className="flex items-center justify-center pb-6 text-center font-display text-6xl leading-18 text-blue sm:pb-0 md:col-span-2">
          About Us
        </div>
        <p className="md:col-span-4">
          At Provido, we are dedicated to empowering people living with
          disability to live independently, achieve their goals, and participate
          fully in their communities.
          <br />
          <br />
          As a trusted NDIS provider, we deliver person-centred support that is
          tailored to the unique needs, aspirations, and circumstances of every
          participant. We believe that quality support goes beyond meeting
          everyday needs; it is about creating opportunities, building
          confidence, and helping people live the life they choose.
        </p>
      </div>

      {/* Our Approach and Mission */}
      <div className="grid grid-cols-1 gap-12 px-12 py-16 md:px-24 lg:grid-cols-2 lg:px-12 xl:px-36">
        <div>
          <h2 className="pb-12 text-center font-display text-4xl text-purple">
            Our Approach
          </h2>
          <p>
            We understand that no two participants are the same. That's why we
            take the time to get to know each individual, their goals,
            preferences, and support needs.
            <br />
            <br />
            By working closely with participants, families, carers, and support
            coordinators, we develop personalised support plans that promote
            independence, wellbeing, and meaningful outcomes.
            <br />
            <br />
            Our approach is built on:
          </p>
          <ul className="text-list">
            <li>Respect and dignity</li>
            <li>Choice and control</li>
            <li>Inclusion and community participation</li>
            <li>Independence and skill development</li>
            <li>Reliability and consistency</li>
            <li>Compassionate, participant-focused care</li>
          </ul>
        </div>
        <img
          src={ApproachImage}
          className="my-auto w-full"
          alt="Illustration: two people, one is speaking and the other is taking notes."
        />
      </div>
      <div className="grid grid-cols-1 gap-12 px-12 py-16 md:px-24 lg:grid-cols-2 lg:px-12 xl:px-36">
        <img
          src={MissionImage}
          className="order-2 my-auto w-full lg:order-1"
          alt="Illustration: three people putting up a yellow flag with a star on it."
        />
        <div className="order-1 lg:order-2">
          <h2 className="pb-12 text-center font-display text-4xl text-purple">
            Our Mission
          </h2>
          <p>
            Our mission is to empower people living with disability to live
            fulfilling, independent, and meaningful lives through high-quality,
            person-centred support.
            <br />
            <br />
            We are committed to creating opportunities for participants to
            achieve their goals, build confidence, develop new skills, and
            actively engage in their communities. By delivering supports that
            are tailored to individual needs and aspirations, we strive to help
            participants exercise greater choice and control over their lives
            while maintaining their independence and wellbeing.
            <br />
            <br />
            At Provido, we believe that every person deserves to be treated with
            dignity, respect, and compassion. We are passionate about fostering
            an inclusive environment where participants feel valued, supported,
            and empowered to reach their full potential.
            <br />
            <br />
            Through strong relationships, collaborative care, and a commitment
            to excellence, we aim to make a positive and lasting difference in
            the lives of the individuals, families, and communities we support.
            Every day, we work to ensure our services not only meet participant
            needs but also encourage growth, connection, and meaningful outcomes
            that enhance quality of life.
          </p>
        </div>
      </div>

      {/* Why Choose Provido */}
      <div className="w-dvw bg-skyblue bg-[url(./assets/images/darkbubblebg.webp)] px-8 py-24">
        <div className="mx-auto max-w-3xl text-white">
          <h2 className="pb-8 text-center font-display text-4xl text-darkblue">
            Why Choose Us?
          </h2>
          <p>
            At Provido, we pride ourselves on delivering support that is
            professional, flexible, and genuinely focused on the people we
            serve.
            <br />
            <br />
            When you choose us, you can expect:
          </p>
          <ul className="text-list">
            <li>Person-centred support tailored to your needs</li>
            <li>Experienced and caring support professionals</li>
            <li>Flexible services designed around your goals</li>
            <li>Open communication and collaborative care</li>
            <li>A commitment to quality, respect, and inclusion</li>
          </ul>
          <p>
            We believe everyone deserves the opportunity to thrive, and we are
            proud to support participants in building the skills, confidence,
            and independence needed to achieve their goals.
          </p>
        </div>
      </div>
    </main>
  );
};

export default About;
